import './SearchResults.css';

import { Col, Icon, Modal, Pagination, Row } from 'antd';
import * as React from 'react';

import { ReactiveList, SelectedFilters } from '@appbaseio/reactivesearch';

import ResultCard from './cards/ResultCard';

const { ResultCardsWrapper } = ReactiveList;

export interface SearchResultsProps {}

export class SearchResults extends React.Component<SearchResultsProps, any> {
  constructor(props: SearchResultsProps) {
    super(props);
    this.state = {
      viewedResults: [],
    };
  }

  readonly pageSize: number = 15;
  readonly numberOfPagesMax: number = 100;

  onPaginationChange = (pageNumber: number) => {
    if (pageNumber + 1 > this.numberOfPagesMax) {
      Modal.warning({
        icon: <Icon type='exclamation-circle' style={{ fontSize: '2.5em' }}/>,
        content: (
          <>
            <br/>
            <br/>
            <p>Unable to fetch more than {this.numberOfPagesMax} pages of search results. Please use filters in the 'Refine Search' section to narrow down your search criteria.</p>
          </>
        ),
      });
    } else {
      this.loadPage(pageNumber);
    }
  };

  loadPage = (pageNumber: number) => {};

  renderResultStats = (stats: any) => {
    const start = this.pageSize * stats.currentPage + 1;
    const end = this.pageSize * (stats.currentPage + 1);
    return (
      <p style={{ fontSize : '0.8em', padding: '10px' }}>
        Results {start} - {stats.numberOfResults < end ? stats.numberOfResults : end} of {stats.numberOfResults} matches
      </p>
    );
  };

  markResultAsViewed = (id: string) => {
    this.state.viewedResults.push(id);
    this.setState({ viewedResults: this.state.viewedResults });
  };

  public render() {
    return (
      <div className='rounded-box'>
        <div id='result_pane'>
          <h3>
            <Icon type='file'/> Search Results
          </h3>
          <SelectedFilters showClearAll={true}/>
          <br/>
          <ReactiveList
            componentId='SearchResult'
            dataField='_score'
            pagination={true}
            react={{
              and: [
                'keywordSearch',
                'attributeSearch',
                'fromYearAttributeSearch',
                'toYearAttributeSearch',
                'parishNameFilter',
                'countyNameFilter',
                'districtOfficeFilter',
                'collectionFilter',
                'lotSearch'
              ]
            }}
            size={this.pageSize}
            children={({ data, resultStats }) => (
              <ResultCardsWrapper>
                <Row gutter={16} type='flex'>
                  {data.map((row: any) => (
                    <Col xs={24} lg={12} xxl={8} className='resultCard' key={row._id}>
                      <ResultCard data={row} viewed={this.state.viewedResults.includes(row._id)} markAsViewed={this.markResultAsViewed}/>
                    </Col>
                  ))}
                </Row>
                <Pagination
                  style={{ marginTop: '20px' }}
                  pageSize={this.pageSize}
                  total={resultStats.numberOfResults}
                  current={resultStats.currentPage + 1}
                  onChange={(page) => this.onPaginationChange(page - 1)}
                  showQuickJumper={true}
                  locale={{ 'jump_to': 'Go to page'}}
                />
              </ResultCardsWrapper>
            )}
            renderPagination={({ setPage }) => { this.loadPage = setPage; }}
            renderResultStats={this.renderResultStats}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/search/SearchResults.tsx